<template>
  <v-card class="afrus-d-rounded-card">
    <v-card-title>
      <v-flex
        xs10
        class="title"
        pl-4
      >
        {{ $t('profile.options.password') }}
      </v-flex>
      <v-flex
        xs2
        class="text-xs-right"
      >
        <v-btn
          color="#02579b"
          rounded
          dark
          @click="changePass"
        >
          {{ $t('general.save') }}
        </v-btn>
      </v-flex>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-layout
        row
        wrap
        pa-5
      >
        <v-flex
          xs12
          pa-5
        >
          <v-text-field
            v-model="password"
            v-validate="'required'"
            required
            :label="$t('profile.password.current')"
            :error-messages="errors.collect($t('profile.password.current'))"
            :data-vv-name="$t('profile.password.current')"
            type="password"
          />
        </v-flex>
        <v-layout
          wrap
          pt-4
          pa-5
        >
          <v-flex xs6 pr-2>
            <v-text-field
              ref="password"
              v-model="new_password"
              :label="$t('profile.password.new')"
              required
              type="password"
            />
          </v-flex>
          <v-flex xs6 pl-2>
            <v-text-field
              v-model="confirm"
              v-validate="'required|confirmed:password'"
              :label="$t('profile.password.confirm')"
              :error-messages="errors.collect($t('profile.password.confirm'))"
              :data-vv-name="$t('profile.password.confirm')"
              required
              type="password"
            />
          </v-flex>
        </v-layout>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'AccountPassword',
  data: () => ({
    password: '',
    new_password: '',
    confirm: ''
  }),
  methods: {
    ...mapActions({
      changePassword: 'auth/changePassword'
    }),
    async changePass() {
      const isValid = await this.$validator.validateAll()
      if (isValid) {
        const { password, new_password, confirm } = this
        let body = {
          currentPassword: password,
          newPassword: new_password,
          newPassword_confirmation: confirm
        }
        await this.changePassword(body)
          .then(
            res => {
              this.$noty.success(this.$t('profile.password.success'))
              this.password = ''
              this.new_password = ''
              this.confirm = ''
            },
            err => {
              this.$noty.error(this.$t('profile.password.error'))
            }
          )
      }
    }
  }
}
</script>

<style>

</style>